import React, { useState } from 'react';

import { Box, Drawer } from '@mui/material';

import Navbar from 'src/components//common/navbar/Navbar';
import HeaderBar from 'src/components/common/header/HeaderBar';

interface IAppLayoutProps {
	children: React.ReactNode;
}

const AppLayout: React.FC<IAppLayoutProps> = ({
	children,
}): React.JSX.Element => {
	const [isNavbarOpen, setIsNavbarOpen] = useState(false);

	const toggleNavbar = () => {
		setIsNavbarOpen(!isNavbarOpen);
	};

	const hideNavbar = () => {
		setIsNavbarOpen(false);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				maxWidth: '100vw',
				minHeight: '100vh',
			}}
		>
			<HeaderBar toggleNavbar={toggleNavbar} />
			<Box sx={{ display: 'flex', flex: 1 }}>
				<Drawer
					anchor='left'
					open={isNavbarOpen}
					onClose={hideNavbar}
					sx={{
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							borderRight: '1px solid #00000020',
						},
					}}
				>
					<Navbar hideNavbar={hideNavbar} />
				</Drawer>
				<Box
					component='main'
					sx={{
						flexGrow: 1,
						p: 3,
						backgroundColor: '#F9F9F9',
						maxWidth: '100vw',
						minHeight: 'calc(100vh - 4.5rem)',
					}}
				>
					{children}
				</Box>
			</Box>
		</Box>
	);
};

export default AppLayout;
